import {mapActions, mapState} from 'vuex'
import * as types from '@/store/types'

export default {
  computed: {
    ...mapState({
      loadingGui: state => state.gui.loading,
      errorGui: state => state.gui.error.show,
      warningGui: state => state.gui.warning.show,
      guiSettingsLayout: state => state.gui.settings.layout
    })
  },
  methods: {
    ...mapActions({
      loadingSet: types.GUI.loading.set
    }),
    setLoadingGui() {
      this.loadingSet(true)
    },
    unsetLoadingGui() {
      this.loadingSet(false)
    }
  }
}
